class ScrollToElement {
	constructor(element, offset = 0, id = false) {
			this.element = element;
			this.id = id;
			this.offset = offset;

			this.doScrolling((element.getBoundingClientRect().top + document.querySelector('c-content').scrollTop) - this.offset, 300);
	}

	doScrolling(elementY, duration) { 
			var startingY = window.pageYOffset;
			var diff = elementY - startingY;
			var start;
		
			// Bootstrap our animation - it will get called right before next frame shall be rendered.
			window.requestAnimationFrame(function step(timestamp) {
				if (!start) start = timestamp;
				// Elapsed milliseconds since start of scrolling.
				var time = timestamp - start;
				// Get percent of completion in range [0, 1].
				var percent = Math.min(time / duration, 1);
		
				console.log(startingY, diff, percent);
				document.querySelector('c-content').scrollTo(0, startingY + diff * percent);
		
				// Proceed with animation as long as we wanted it to.
				if (time < duration) {
					window.requestAnimationFrame(step);
				}
			})
	}

	focusFirstItem() {
			if(this.id) {
					window.location.href.split('#')[0]
					window.location.hash = `${this.id}`;
			} else {
					const focusable = [...this.element.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')];
					if(focusable.length) focusable[0].focus();
			}
	}
}

export default ScrollToElement;